import { lazy, ComponentType } from 'react';
import type { SendReferralTrackingDataProps } from './send-referral-tracking-data';

export const SendReferralTrackingData = lazy<ComponentType<SendReferralTrackingDataProps>>(() =>
  import('./send-referral-tracking-data').then((m) => ({ default: m.SendReferralTrackingData }))
);
